/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_standings_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This page shows the official F1 World Championship standings — the points drivers and constructors earn from their finishing positions each race (25 for a win, 18 for 2nd, 15 for 3rd, and so on).`)
};

const es_f1_standings_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta página muestra la clasificación oficial del Campeonato Mundial de F1 — los puntos que pilotos y constructores obtienen por sus posiciones de llegada en cada carrera (25 por victoria, 18 por 2.°, 15 por 3.°, etc.).`)
};

const de_f1_standings_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Seite zeigt die offizielle F1-WM-Wertung — die Punkte, die Fahrer und Konstrukteure für ihre Platzierungen in jedem Rennen erhalten (25 für einen Sieg, 18 für Platz 2, 15 für Platz 3 usw.).`)
};

const nl_f1_standings_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze pagina toont de officiële F1 WK-stand — de punten die coureurs en constructeurs verdienen op basis van hun finishpositie in elke race (25 voor winst, 18 voor 2e, 15 voor 3e, enzovoort).`)
};

const fr_f1_standings_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette page affiche le classement officiel du Championnat du Monde F1 — les points que les pilotes et constructeurs gagnent selon leur position d’arrivée à chaque course (25 pour une victoire, 18 pour la 2e place, 15 pour la 3e, etc.).`)
};

const it_f1_standings_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa pagina mostra la classifica ufficiale del Campionato Mondiale F1 — i punti che piloti e costruttori ottengono in base alla posizione di arrivo in ogni gara (25 per la vittoria, 18 per il 2°, 15 per il 3° e così via).`)
};

const pt_br2_f1_standings_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta página mostra a classificação oficial do Campeonato Mundial de F1 — os pontos que pilotos e construtores ganham pela posição de chegada em cada corrida (25 pela vitória, 18 pelo 2.°, 15 pelo 3.° e assim por diante).`)
};

const pt_f1_standings_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta página mostra a classificação oficial do Campeonato Mundial de F1 — os pontos que pilotos e construtores ganham pela sua posição de chegada em cada corrida (25 pela vitória, 18 pelo 2.°, 15 pelo 3.°, e assim por diante).`)
};

const ja_f1_standings_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このページはF1世界選手権の公式順位表を表示します — 各レースでドライバーとコンストラクターがフィニッシュ順位に応じて獲得するポイント（優勝25点、2位18点、3位15点など）です。`)
};

const zh_f1_standings_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此页面显示F1世界锦标赛官方积分榜 — 车手和车队根据每场比赛的完赛位置获得的积分（冠军25分，亚军18分，季军15分，以此类推）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_standings_how_p1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_standings_how_p1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_standings_how_p1", locale)
	if (locale === "en") return en_f1_standings_how_p1(inputs)
	if (locale === "es") return es_f1_standings_how_p1(inputs)
	if (locale === "de") return de_f1_standings_how_p1(inputs)
	if (locale === "nl") return nl_f1_standings_how_p1(inputs)
	if (locale === "fr") return fr_f1_standings_how_p1(inputs)
	if (locale === "it") return it_f1_standings_how_p1(inputs)
	if (locale === "pt-BR") return pt_br2_f1_standings_how_p1(inputs)
	if (locale === "pt") return pt_f1_standings_how_p1(inputs)
	if (locale === "ja") return ja_f1_standings_how_p1(inputs)
	return zh_f1_standings_how_p1(inputs)
};